import React from "react";

const TransferNodeButton = ({ transferNode }) => {
  return (
    <button
      onClick={() => {
        transferNode();
      }}
      type={"button"}
      className="w-full rounded-lg flex justify-center items-center h-10 border transition-all duration-300 border-deepBlue dark:text-white bg-white dark:bg-darkCardBg hover:bg-iceBlue active:translate-x-[1px] active:translate-y-[1px]  shadow-swapButton text-sm leading-[21px] text-black dark:hover:!bg-[#3C3A66]"
    >
      Transfer Nodes
    </button>
  );
};

export default TransferNodeButton;
